<template>
  <div class="import-narrativebook-modal">
    <modal-frame :showModalFlag="modalDisplay" v-on:backdropClickEvent="cancel">
      <div class="modal-header">
        <div class="headline">
          <h1>連絡先インポート</h1>
          <img src="/images/close_icon.svg" @click="cancel"/>
        </div>
        <div class="header-controll" @click="toggleShowOnlyAvailable">
          <custom-check-box
            :type="'color'"
            :active="showOnlyAvailable"
            :enabled="true"
          />
          <span>利用可能な連絡先のみ表示</span>
        </div>
      </div>
      <div class="modal-body">
        <div class="address-group-column"
          v-for="group in addressSelectedState"
          :key="'impnbg' + group.id"
          >
          <div class="address-group-header" @click="toggleGroupDisplay(group)">
            <span class="group-name">{{ group.name }}</span>
            <img src="/images/list-open.svg" v-show="group.display"/>
            <img src="/images/list-close.svg" v-show="!group.display"/>
          </div>
          <div class="address-entries-column" v-show="group.display">
            <div class="address-entry-column"
              v-for="entry in group.addresses"
              :key="'impnbe' + entry.id"
              v-show="entry.narrative_phone_id || !showOnlyAvailable"
              :class="{disable: entry.exist || !entry.narrative_phone_id}"
              @click="toggleSelect(entry)">
              <custom-check-box
                :type="'color'"
                :active="entry.selected"
                :enabled="!entry.exist && entry.narrative_phone_id"
              />
              <div class="entry-info">
                <div class="entry-name">{{ entry.name }}</div>
                <div class="entry-state" v-if="entry.exist && entry.narrative_phone_id">インポート済み</div>
                <div class="entry-state" v-if="!entry.exist && entry.narrative_phone_id">未インポート</div>
                <div class="entry-state" v-if="!entry.narrative_phone_id">ナラティブフォン未登録</div>
              </div>
            </div>
          </div>
        </div>
        <div class="import-failed" v-if="loadFailed">
          ナラティブブックからのアドレス帳インポートに失敗しました。
        </div>
        <div class="category-info">
          <span class="caption">連絡先グループ[{{ category.name }}]へインポート</span>
        </div>
        <div class="form-controll">
          <button class="cancel-btn" @click="cancel">キャンセル</button>
          <button class="submit-btn" @click="submit">インポート</button>
        </div>
      </div>
    </modal-frame>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import ModalFrame from '@/components/common/ModalFrame.vue'
import CustomCheckBox from '@/components/common/CustomCheckBox.vue'

export default {
  name: 'ImportNarrativebookModal',

  components: {
    ModalFrame,
    CustomCheckBox,
  },

  props: {
    category: Object,
    modalDisplay: Boolean,
  },

  emits: [
    'cancelEvent',
    'addressImportFinishEvent',
    'addressImportFetchFailedEvent',
    'addressImportFailedEvent',
  ],

  data () {
    return {
      addressSelectedState: [],
      showOnlyAvailable: true,
      loadFailed: false,
    }
  },

  watch: {
    modalDisplay: { handler: 'initData', immediate: true },
    narrativebookLists: { handler: 'loadNBData' },
  },

  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser,
      addressBook: state => state.addressBook.addressCategories,
      narrativebookLists: state => state.addressBook.narrativebookAddresses,
    }),
  },

  methods: {
    ...mapActions({
      createEntry: 'addressBook/createEntry',
      fetchListFromNarrativebook: 'addressBook/fetchListFromNarrativebook',
    }),

    initData () {
      if (this.modalDisplay) {
        this.initSelection()
        this.showOnlyAvailable = true
      }
    },

    initSelection () {
      this.addressSelectedState = []
      try {
        this.fetchListFromNarrativebook()
      } catch (error) {
        console.log('inport narrativebook error,')
        console.error(error)
        this.loadFailed = true
        this.$emit('addressImportFetchFailedEvent')        
      }
    },

    loadNBData () {
      this.addressSelectedState = []
      console.log(this.narrativebookLists)
      for(let nbGroup of this.narrativebookLists) {
        console.log(nbGroup)
        let stateGroup = { name: nbGroup.name, id: nbGroup.id, display: true, addresses: [] }
        console.log(stateGroup)
        if (nbGroup.addresses) {
          for(let nbAddress of nbGroup.addresses) {
            let stateAddress = {
              id: nbAddress.id,
              narrative_phone_id: nbAddress.narrative_phone_id,
              nbid: nbAddress.nbid,
              author_id: nbAddress.author_id,
              organization_id: nbAddress.organization_id,
              name: nbAddress.name,
              description: nbAddress.description,
              icon_image_path: nbAddress.icon_image_path,
              selected: false,
            }
            if (this.category.address_entries.some((e) => e.narrative_phone_id === nbAddress.narrative_phone_id)) {
              stateAddress.exist = true
            }
            stateGroup.addresses.push(stateAddress)
          }
        }
        this.addressSelectedState.push(stateGroup)
      }
    },

    toggleShowOnlyAvailable () {
      this.showOnlyAvailable = !this.showOnlyAvailable
    },

    toggleGroupDisplay (group) {
      group.display = !group.display
    },

    toggleSelect (entry) {
      if (entry.narrative_phone_id && !entry.exist) {
        entry.selected = !entry.selected
      }
    },

    cancel () {
      this.$emit('cancelEvent')
    },

    async submit () {
      // let promiseActions = []
      let successEntry = []
      let failedEntry = []
      for(let group of this.addressSelectedState) {
        for(let entry of group.addresses) {
          if (entry.selected) {
            let formData = new FormData()
            formData.append('narrative_phone_id', entry.narrative_phone_id)
            formData.append('address_category_id', this.category.id)
            await this.createEntry(formData).then(() => {
              successEntry.push(entry)
            }).catch(error => {
              console.error(error)
              failedEntry.push(entry)
            })
            // promiseActions.push(
            //   // NOTE: 個別に結果を返すべき？
            //   this.createEntry(formData)
            // )
          }
        }
      }
      let message = ''
      message += 'ナラティブブックからインポート\n結果: 成功[' + successEntry.length + ']件/失敗[' + failedEntry.length + ']件\n'
      if (successEntry.length > 0) {
        message += '成功\n'
        for(let sucEnt of successEntry) {
          message += sucEnt.name + '\n'
        }
      }
      if (failedEntry.length > 0) {
        message += '失敗\n'
        for(let failEnt of failedEntry) {
          message += failEnt.name + '\n'
        }
      }
      if (failedEntry.length > 0) {
        this.$emit('addressImportFailedEvent', message)
      } else {
        this.$emit('addressImportFinishEvent', message)
      }
      // すべてが成功、失敗するわけではないので、個別に結果を返すべき？
      // Promise.all(promiseActions).then(res => {
      //   console.log(res)
      //   // finished
      //   // 成功結果をメッセージに
      //   let message = 'ナラティブブックから連絡先をインポートしました。'
      //   this.$emit('addressImportFinishEvent', message)
      // }).catch(error => {
      //   console.error(error)
      //   // 失敗結果をメッセージに
      //   let message = 'ナラティブブックからの連絡先インポートに失敗しました。'
      //   this.$emit('addressImportFailedEvent', message)
      // })
    },
  }
  
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.import-narrativebook-modal {
  margin: 0;
  .modal-header {
    padding: 15px;
    padding-bottom: 0;
    .headline {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h1 {
        margin: 0;
        font-size: 22pt;
        font-weight: normal;
      }
      img {
        height: 40px;
      }
    }
    .header-controll {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      span {
        border-bottom: 2px solid $success-color;
      }
    }
  }
  .modal-body {
    padding: 20px;
    .address-group-column {
      .address-group-header {
        display: flex;
        align-items: center;
        font-size: 12pt;
        border-bottom: 1px solid #aaa;
        img {
          margin-left: 10px;
          height: 20px;
        }
      }
      .address-entries-column {
        .address-entry-column {
          display: flex;
          align-items: center;
          margin: 10px;
          padding: 10px;
          border-bottom: 1px solid #aaa;
          &.disable {
            color: #999;
          }
          .entry-info {
            margin-left: 20px;
            .entry-name {
              font-size: 16pt;
            }
            .entry-state {
              font-size: 10pt;
            }
          }
        }
      }
    }
    .import-failed {
      margin-bottom: 20px;
      padding: 10px;
      border: 1px solid $danger-color;
    }
    .category-info {
      margin: 10px 0;
      text-align: right;
      .caption {
        border-bottom: 1px solid $success-color;
      }
    }
  }
}
</style>